import { useState } from 'react'

import { useFilePreviewGallery } from '../../../FilesPreviewGallery'
import {
  DocFlowMappingResultTableCell,
  generateDocFlowMappingResultPdfUrl,
} from '../../DocFlowMapping'
import { useDocFlowMappingContext } from '../useDocFlowMappingContext'

export function useDocFlowMappingResultPdf({ item }) {
  const { activeFile, activeFileBytes } = useDocFlowMappingContext()

  const [newUrl, setNewUrl] = useState(null)

  const preparedFile = { ...activeFile, localUrl: newUrl }

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files: [preparedFile],
    })

  async function handleClickResultFile(fileId) {
    await generateDocFlowMappingResultPdfUrl({
      activeFileBytes,
      pagesRange: item?.[DocFlowMappingResultTableCell.PagesRange],
    }).then(setNewUrl)

    handleClickFile(fileId)
  }

  return {
    activeFile,
    activeFileIndex,
    handleClickResultFile,
    handleCloseFilePreview,
    preparedFile,
  }
}
